<script setup>
import { useOnline } from '@vueuse/core'

const isOnline = useOnline()
</script>

<template>
  <div v-if="!isOnline" class="w-100 text-center bg-red pa-4" style="position: fixed; bottom: 0; z-index: 9999">{{ $t('no_internet_connection_check_your_connection') }}!</div>
</template>
